module.exports = __webpack_public_path__ + "img/info.8e09dba3.svg";